import React, { useEffect, useRef } from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

import { BandCard } from "../../components";
import { BANDS2022 as bands } from "../../utils";

import { MainLayout } from "../../layouts";

import { useNavigate, useLocation } from "react-router-dom";

import "./styles.css";

function SawtiIlak2022() {
  let navigate = useNavigate();
  let location = useLocation();

  const bandsRef = useRef();
  const judgesRef = useRef();

  const scrollToRef = (ref) => {
    ref.current.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    if (location.hash) {
      if (location.hash === "#bands") {
        scrollToRef(bandsRef);
      } else if (location.hash === "#judges") {
        scrollToRef(judgesRef);
      }
    }
  }, [location.hash]);

  return (
    <MainLayout>
      <div className="py-2">
        <div className="bands-backdrop" style={{backgroundColor: "#2F1937"}}>
          <Container className="pb-3">
            <Row>
              <Col xs={9} className="d-flex">
                <h1 className="sawti-ilak-2021 text-center">Sawti Ilak 2022</h1>
              </Col>
              <Col
                xs={3}
                className="d-flex justify-content-end align-items-center"
              >
                <Button
                  variant="light"
                  onClick={() => {
                    navigate("/sawti-ilak-pictures/2022");
                  }}
                  className={"pictures-button"}
                >
                  Pictures
                </Button>
              </Col>
            </Row>
            <Row ref={bandsRef} className="d-flex justify-content-center pt-2">
              <div className="divider w-100" style={{ opacity: 0.25 }}></div>
            </Row>
            {bands.map((band, index) => {
              if (index <= 1) {
                return (
                  <div key={`parent-${index}`}>
                    <BandCard key={`band-${index}`} {...band} />
                    <Row
                      key={`divider-parent-${index}`}
                      className="d-flex justify-content-center pt-2"
                    >
                      <div
                        key={`divider-${index}`}
                        className="thin-divider"
                      ></div>
                    </Row>
                  </div>
                );
              } else if (index === bands.length-1) {
                return (
                  <div key={`parent-${index}`}>
                    <BandCard key={`band-${index}`} {...band} />
                  </div>
                );
              } else if (index === bands.length - 1) {
                return <BandCard key={`band-${index}`} {...band} />;
              } else {
                return (
                  <div key={`parent-${index}`}>
                    <BandCard key={`band-${index}`} {...band} />
                    <Row
                      key={`divider-parent-${index}`}
                      className="d-flex justify-content-center pt-2"
                    >
                      <div
                        key={`divider-${index}`}
                        className="thin-divider"
                      ></div>
                    </Row>
                  </div>
                );
              }
            })}
          </Container>
        </div>
      </div>
    </MainLayout>
  );
}

export default SawtiIlak2022;
